<template>
  <div class="row">
    <div
      v-for="([key, dynamicField]) of Object.entries(identificationDynamicFields)"
      :class="
          dynamicField.css_class
            ? dynamicField.css_class
            : {
                'col-6': dynamicField.type !== 'ckeditor',
                'col-12': dynamicField.type === 'ckeditor',
              }
        "
      :key="dynamicField.name"
    >
      <!--      <pre>{{key}}</pre>-->
      <!--      <pre>{{dynamicField}}</pre>-->
      <input-widget
        :hint="dynamicField.hint"
        :type="typeMap[dynamicField.type]"
        :label="$t(dynamicField.label)"
        :id="'identityVerificationDynamicField_' + key"
        :rules="getRules(key, dynamicField)"
        v-model="model[key]"
        @change="onChange(key, dynamicField, $event)"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {mapGetters, mapState, mapMutations} from "vuex";
import InputWidget from "@/components/core/InputWidget.vue";

export default {
  name: "DynamicFieldInputs",
  components: {InputWidget},
  props: {
    requiredFields: {
      type: Array,
      default: () => []
    }
  },
  inject: {
    disabledState: {
      default: () => Vue.observable({ disabled: false })
    }
  },
  data: () => ({
    model: {},
    typeMap: {
      text: "text",
      checkbox: "checkbox",
    },
  }),
  computed: {
    disabled() {
      return this.disabledState.disabled;
    },
    ...mapState(['identityVerification']),
    ...mapGetters(['identificationDynamicFields']),
  },
  watch: {
    'identityVerification.model.dynamic_fields': {
      immediate: true,
      handler() {
        this.model = {
          ...this.identityVerification.model.dynamic_fields,
        }
      }
    }
  },
  methods: {
    ...mapMutations(['identityVerificationFieldOnInput']),
    getRules(fieldKey, dynamicField) {
      let rules = [];
      for (let i in dynamicField.rules) {
        if (i === "required") {
          // Override required rule if requiredFields array has items
          if (this.requiredFields.length > 0) {
            if (this.requiredFields.includes(fieldKey)) {
              rules.push("required");
            }
          } else {
            // Use original logic if requiredFields is empty
            if (dynamicField.rules[i]) {
              rules.push("required");
            }
          }
        }
      }
      return rules.join("|");
    },
    onChange(key, field, val) {

      this.identityVerificationFieldOnInput({
        field: 'dynamic_fields',
        value: {
          ...this.model,
          [key]: val
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
